export default "__VITE_ASSET__b2JG_4Mj__"